export enum LoyaltyStatus {
  HERO = 'Hero',
  STAR = 'Star',
  SUPERSTAR = 'SuperStar',
  DIAMOND = 'Diamond',
  LEGEND = 'Legend',
  ICON = 'Icon',
}

export type LoyaltyStatusMultipliers = {
  gcMultiplier: string
  pointsMultiplier: string
}

export const LoyaltyStatusMultipliersMap: Record<LoyaltyStatus, LoyaltyStatusMultipliers> = {
  [LoyaltyStatus.HERO]: {
    gcMultiplier: 'x1',
    pointsMultiplier: 'x1',
  },
  [LoyaltyStatus.STAR]: {
    gcMultiplier: 'x1.25',
    pointsMultiplier: 'x2',
  },
  [LoyaltyStatus.SUPERSTAR]: {
    gcMultiplier: 'x1.5',
    pointsMultiplier: 'x3',
  },
  [LoyaltyStatus.DIAMOND]: {
    gcMultiplier: 'x1.75',
    pointsMultiplier: 'x4',
  },
  [LoyaltyStatus.LEGEND]: {
    gcMultiplier: 'x2',
    pointsMultiplier: 'x5',
  },
  [LoyaltyStatus.ICON]: {
    gcMultiplier: 'x2.25',
    pointsMultiplier: 'x6',
  },
}
